import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UserSubscription, UserSubscriptionCategory} from "../../../../../user/user-subscription";
import {SizePipe} from "../../../../pipes/size.pipe";
import {CountPipe} from "../../../../pipes/count.pipe";
import {GoogleAnalyticsService} from "../../../../services/google-analytics/google-analytics.service";
import cdnFeatures from "./cdn-features.json";
import {ActivatedRoute} from "@angular/router";

interface Point {
  title: string;
  subPoints?: string[];
}

@Component({
    selector: 'db-booster-account-upgraded',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './booster-account-upgraded.component.html',
    styleUrls: ['./booster-account-upgraded.component.scss'],
    standalone: false
})
export class BoosterProUpgradedComponent implements OnInit {

  @Input() subscription: UserSubscription;
  @Input() upgradeableSubscription: UserSubscription | null;
  @Input() fromBooster?: boolean;
  @Output() onProceed: EventEmitter<void> = new EventEmitter<void>();

  public UserSubscriptionCategory: any = UserSubscriptionCategory;

  public cdnPoints: Point[] = [
    {
      title: 'Full frontend optimization'
    },
    {
      title: 'Cloudflare Enterprise CDN'
    },
  ];

  constructor(
    private count: CountPipe,
    private size: SizePipe,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _route: ActivatedRoute,
  ) { }

  ngOnInit() {
      this._getCDNeatures();
  }

  private _getCDNeatures(): void {
    if (this.subscription && this.subscription.plan.cdnService) {
      cdnFeatures['cdn_features'].unshift(`${this.size.transform(this.subscription.plan.cdnService.cdn_bandwidth.parameter_value * 1024 * 1024)} Bandwidth`);
    }
    this.cdnPoints[0].subPoints = cdnFeatures['full_frontend_optimization'];
    this.cdnPoints[1].subPoints = cdnFeatures['cdn_features'];
  }
}
